import React, { useMemo } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { useAppContext } from "@state/hooks/shared";

import HeaderLoginButton from "./HeaderLoginButton";
import HeaderRegistrationButton from "./HeaderRegistrationButton";

export default function HeaderAuthenticationButtons() {
	const { t } = useTranslation();
	const { culture } = useAppContext();
	// remember that useLocation is affected by another hook, so any component using it rerenders onscroll
	const { pathname, search } = useLocation();

	const affiliateCode = useMemo(
		() => new URLSearchParams(search).get("afc"),
		[search]
	);
	const isRegistrationButtonHidden = useMemo(
		() =>
			!WEBPACK_IS_REGISTRATION_ENABLED ||
			pathname === `/${culture}/auth/register`,
		[pathname]
	);

	if (affiliateCode) {
		return null;
	}

	return (
		<>
			<HeaderLoginButton
				culture={culture}
				isRegistrationButtonHidden={isRegistrationButtonHidden}
				text={t("HEADER.LOGIN")}
			/>
			{!isRegistrationButtonHidden && (
				<HeaderRegistrationButton
					culture={culture}
					text={t("COMMON.REGISTRATION_TITLE")}
				/>
			)}
		</>
	);
}
